export default __webpack_public_path__ + "static/media/3-tone-bangle-bracelet.ba8d9bff.jpg";